import { queryOptions, useQuery } from '@tanstack/react-query'
import { apiClient } from '~/lib/api-client'
import { CACHE_CONFIG } from '~/lib/cache-config'

export async function fetchCategoryGuide(categoryId: string, lang: string) {
  // @ts-ignore: Hono client type inference issue with nested param paths
  const res = await apiClient.categories[':id'].guide.$get({
    param: { id: categoryId },
    query: { lang },
  })
  if (!res.ok) {
    if (res.status === 404) return null
    throw new Error(`Failed to fetch category guide ${categoryId}: ${res.status}`)
  }
  return res.json()
}

export function categoryGuideQueryOptions(categoryId: string, lang: string) {
  return queryOptions({
    queryKey: ['category-guide', categoryId, lang],
    queryFn: () => fetchCategoryGuide(categoryId, lang),
    staleTime: CACHE_CONFIG.reference.staleTime,
    gcTime: CACHE_CONFIG.reference.gcTime,
    enabled: !!categoryId,
  })
}

export function useCategoryGuide(categoryId: string, lang: string) {
  return useQuery(categoryGuideQueryOptions(categoryId, lang))
}
